export default "__VITE_ASSET__C_VvT6Qp__"